<template>
  <div class="pdf-right-panel-unit pdf-right-panel-unit--added-pdf">
    <roe-article-view ref="articleView"></roe-article-view>
    <div v-for="article in articles" class="pdf-right-panel-unit-content">
      <h4>{{ article.title }}</h4>
      <div class="light-label">
        {{ article.bullet_point }}
      </div>
      <div class="pdf-right-panel-unit-content-actions">
        <div class="btn-wrap">
          <button class="btn-warning" @click.stop="remove(article)">
            Remove
          </button>
        </div>
        <div class="btn-wrap">
          <button
            class="btn-secondary"
            @click.stop="$refs.articleView.open(article)"
          >
            More info
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REPORT_ARTICLE_DESTROY } from "@/store/actions.type";
import RoeArticleView from "./ArticleView";
export default {
  name: "RoeSelectedArticles",
  components: { RoeArticleView },
  props: {
    articles: {
      type: Array,
      required: true
    }
  },
  methods: {
    remove(article) {
      this.$store.dispatch(REPORT_ARTICLE_DESTROY, {
        reportId: this.$route.params.id,
        articleId: article.id
      });
    }
  }
};
</script>
